import { apiClient } from './client';

export type PreferencesData = Record<string, unknown>;

export const preferencesApi = {
  async get(): Promise<PreferencesData> {
    const response = await apiClient.instance.get<PreferencesData>('/auth/me/preferences');
    return response.data;
  },
  /** Merge: given keys replace, null deletes. */
  async patch(data: PreferencesData): Promise<PreferencesData> {
    const response = await apiClient.instance.patch<PreferencesData>('/auth/me/preferences', { data });
    return response.data;
  },
};
